import React, { useState, useEffect } from "react";
import AdminLeft from "./AdminLeft";
import TopBanner from "./TopBanner";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default function CollectionReport() {
    const [open, setOpen] = useState(true);

    // Sidebar auto collapse
    useEffect(() => {
        const handleResize = () => {
            setOpen(window.innerWidth >= 768);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [data, setData] = useState([]);

    const [totalFee, setTotalFee] = useState(0);
    const [loading, setLoading] = useState(false);

    const formatDate = (dateString) => {
        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };

    const handleSearch = async () => {
        if (!fromDate || !toDate) {
            alert("Select both dates");
            return;
        }

        const url = `https://matrimony.cubixsystems.com/api/search_by_date.php?fromDate=${fromDate}&toDate=${toDate}`;

        setLoading(true); // 👈 start loading

        try {
            const res = await fetch(url);
            const result = await res.json();

            if (result.status) {
                setData(result.records || []);
                setTotalFee(result.totalFee || 0);
            } else {
                setData([]);
                setTotalFee(0);
            }
        } catch (e) {
            console.error(e);
        }

        setLoading(false); // 👈 stop loading
    };


    const [todayTotal, setTodayTotal] = useState(0);
    const fetchTodayTotal = async () => {
        try {
            const res = await fetch("https://matrimony.cubixsystems.com/api/today_total.php");
            const data = await res.json();

            if (data.status) {
                setTodayTotal(data.total || 0);
            }
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchTodayTotal();

        // 🔁 Auto refresh every 5 seconds
        const interval = setInterval(() => {
            fetchTodayTotal();
        }, 5000);

        return () => clearInterval(interval);
    }, []);
    return (
        <div className="container-fluid p-0">
            <div className="d-flex" style={{ height: "100vh" }}>
                {/* LEFT SIDEBAR */}
                <div
                    className="border-end leftcolor"
                    style={{
                        width: open ? "350px" : "0",
                        overflow: "hidden",
                        transition: "0.3s ease"
                    }}
                >
                    {open && (
                        <div className="p-3">
                            <AdminLeft />
                        </div>
                    )}
                </div>

                {/* RIGHT CONTENT */}
                <div
                    className="p-4"
                    style={{
                        width: open ? "calc(100% - 350px)" : "100%",
                        transition: "0.3s ease",
                        paddingLeft: "30px"
                    }}
                >
                    <TopBanner />
                    <div style={{ height: '80vh', overflow: 'auto' }}>
                        <h3>Today's Collection: ₹ {todayTotal}</h3>
                        <hr /> <br />
                        <h3>Chooe Dates</h3>

                        <input
                            type="date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                        />

                        <input
                            type="date"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                            style={{ marginLeft: "10px" }}
                        />

                        <button className="btn" onClick={handleSearch} style={{ marginLeft: "10px",background:'#004962ff',color:'white' }}>
                            Search
                        </button>



                        <div className="row" >
                            <div class="col-md-4">
                                {data.length > 0 && (
                                    <h3 style={{ marginTop: "20px" }}>
                                        Total Amount: ₹ {totalFee}
                                    </h3>
                                )}
                                 {data.length > 0 && (
                                    <p style={{fontSize:'12pt',fontWeight:'600'}}>Total Profiles Found: {data.length}</p>
                                )}
                            </div>
                            
                        </div>



                        {loading && <p>Loading...</p>}
                        <table className="table" style={{ marginTop: "20px" }}>
                            <thead>
                                <tr>
                                    <th style={{ width: '5%' }}>Sl. No.</th> {/* 👈 NEW */}
                                    <th style={{ width: '8%' }}>Bill No.</th>
                                    <th style={{ width: '10%' }}>Date</th>
                                    <th style={{ width: '35%' }}>Name</th>
                                    <th >Amount</th>

                                </tr>
                            </thead>

                            <tbody>
                                {data.length > 0 ? (
                                    data.map((row, index) => ( // 👈 add index
                                        <tr key={row.id}>
                                            <td>{index + 1}</td> {/* 👈 serial number */}
                                            <td>{row.billNo}</td>
                                            <td>{formatDate(row.date)}</td>
                                            <td>{row.name}</td>
                                            <td>{row.fee}</td>

                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4">No data found</td> {/* 👈 updated colspan */}
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}